import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolderOpen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 20,
	viewBox: "0 0 23 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.64 18.67C2.08 18.38 1.62 17.92 1.33 17.36C1 16.72 1 15.88 1 14.2V4.2C1 3.08 1 2.52 1.22 2.09C1.41 1.71 1.72 1.41 2.09 1.22C2.52 1 3.08 1 4.2 1H8.02C8.74 1 9.1 1 9.41 1.11C9.69 1.21 9.95 1.36 10.16 1.57C10.4 1.8 10.56 2.13 10.88 2.77L11.44 3.89L11.72 4.45M4.97 5.22C5.41 5 5.93 5 6.96 5H18.07C19.63 5 20.4 5 20.93 5.33C21.4 5.62 21.73 6.08 21.89 6.64C22.07 7.28 21.91 8.12 21.58 9.8L20.73 14.2C20.41 15.88 20.25 16.72 19.82 17.36C19.45 17.92 18.93 18.38 18.35 18.67C17.69 19 16.91 19 15.36 19H5.75C4.19 19 3.42 19 2.89 18.67C2.42 18.38 2.09 17.92 1.93 17.36C1.75 16.72 1.91 15.88 2.24 14.2L3.39 8.2C3.61 7.08 3.71 6.52 4 6.09C4.25 5.71 4.59 5.41 4.98 5.22H4.97Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFolderOpen;
